import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@nrwl/environment';
import { Observable } from 'rxjs';
import { FeatureFlagEvaluationRequest, FeatureFlagEvaluationResponse } from './feature-flags.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsApiService {
  private readonly http = inject(HttpClient);

  public evaluateFlags(
    data: FeatureFlagEvaluationRequest,
  ): Observable<FeatureFlagEvaluationResponse> {
    return this.http.post<FeatureFlagEvaluationResponse>(
      `${environment.launchDarklyUrl}/v1/flags/evaluate`,
      data,
    );
  }
}
